import { PageLayout } from 'components'

import { NearBeMap } from 'domains/GoogleMaps/components'
import { NearProductsList } from 'domains/Product/components'
import { FilterProvider } from 'contexts'

const Dashboard = () => {
  return (
    <FilterProvider>
      <PageLayout area="near-by-me" headingProps={{ withoutHeader: true }}>
        <NearBeMap />
        <NearProductsList />
      </PageLayout>
    </FilterProvider>
  )
}

export default Dashboard
